import React, { useRef } from 'react';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import PopOver from 'chameleon/ui-stack/ui/base/popover';

const popoverClassName = 'p-0 rounded-2xl';
const ulClassName = 'list-none m-0 p-0';

/**
 * This is a simpler version of the assessments actions component
 *
 * The assessment actions component has a lot of functionality baked in, while this is just a simple button with a popover.
 *
 * The children are expected to be a `<li />` elements.
 */
const SimpleActions = (props) => {
  const label = (
    <ButtonWithIcon isIcon isNaked aria-label="Actions" icon="more-actions" />
  );
  const popover = useRef(null);
  const closePopOver = () => popover.current && popover.current.close();

  return (
    <PopOver ref={popover} contentClassName={popoverClassName} trigger={label}>
      <ul className={ulClassName}>{props.children(closePopOver)}</ul>
    </PopOver>
  );
};
export default SimpleActions;
export { popoverClassName, ulClassName };
